module.exports = __webpack_public_path__ + "static/media/soft-drinks.b49277be.jpg";